class NotificationsBox

  constructor: (options) ->
    @options = options
    @_selectElements()
    @_initState()
    @_bind()
    @$element.data('notifications-box', @)

  _selectElements: ->
    @$element = $(@options.element)
    @$list = @$element.find('.notifications-box-list')
    @$toggle = $(@options.toggle)
    @$count = @$toggle.find('.num')
    @$emptyTip = @$element.find('.noti-pop-empty')

  _initState: ->
    @url = @$toggle.data('unread-notifications-url')
    @needFetch = @_getUnreadCount() > 0

  _bind: ->
    @$element
      .on 'click.notifications-box', '.notifications-box-fetch-button', (e) =>
        e.preventDefault()
        @_hideNewNotice()
        @fetch()

  _update: (data) ->
    @$list.html(data.html)
    tower.adjustReadableTime(@$list)

  _getUnreadCount: ->
    @$toggle.data('unread-count')

  _getItemsCount: ->
    @$element.find('.notifications-group-item').length

  _showNewNotice: ->
    @$element.addClass('has-new')

  _hideNewNotice: ->
    @$element.removeClass('has-new')

  _showSpinner: ->
    @$element.addClass('loading')

  _hideSpinner: ->
    @$element.removeClass('loading')

  _showLoadingTip: ->
    @$element.addClass('loading-new')

  _hideLoadingTip: ->
    @$element.removeClass('loading-new')

  _showEmptyTip: ->
    @$element.addClass('empty')
    @$list.hide()
    @$emptyTip.removeClass('hide').show()

  _hideEmptyTip: ->
    @$element.removeClass('empty')
    @$emptyTip.addClass('hide').hide()
    @$list.show()

  _toggleEmptyTip: ->
    if @_getItemsCount() == 0
      @_showEmptyTip()
    else
      @_hideEmptyTip()

  isActive: ->
    @$element.hasClass('on')

  fetch: ->
    @fetching = true
    @needFetch = false

    @_hideEmptyTip()
    if @$list.children().length == 0
      @_showSpinner()
    else
      @_showLoadingTip()

    $.ajax
      url: @url
      method: 'get'
      dataType: 'json'
    .done (data) =>
      @fetching = false
      @_hideSpinner()
      @_hideLoadingTip()
      @_update(data)
      if @isActive() && @needFetch
        @_showNewNotice()
      else
        @_hideNewNotice()

  receiveNew: ->
    @needFetch = true
    @_showNewNotice() if @isActive() && !@fetching

  markRead: (topicGuids) ->
    topicGuids.forEach (topicGuid) =>
      @$element.find("[data-topic-guid='#{topicGuid}']").remove()
    @_toggleEmptyTip()
    @needFetch = @_getUnreadCount() > @_getItemsCount()

  markAllRead: ->
    @$list.empty()
    @_showEmptyTip()
    @needFetch = @_getUnreadCount() > @_getItemsCount()

  reset: ->
    @_hideNewNotice()
    @_hideSpinner()
    @_showEmptyTip()

$ ->
  tower.notificationsBox = notificationsBox = new NotificationsBox
    element: '.header .notifications-box'
    toggle: '#notification-count'

  $(document)
    .on 'click', '#notification-count', (e) ->
      if notificationsBox.isActive() && notificationsBox.needFetch
        notificationsBox.fetch()
